import { Validations } from "@experta/commons-v2.layout";
import { InsuredValueProps } from "../Insureds/insureds";
import * as lang from "./lang.json";

/**
 * Interface used as props.
 * @name PreferredBeneficiaryProps
 */
export interface PreferredBeneficiaryProps {
    insureds: Array<InsuredValueProps>;
    onChangeFormData?: (formData: any) => void;
}

/**
 * Interface used as props.
 * @name PreferredBeneficiaryFormProps
 */
export interface PreferredBeneficiaryForm {
    beneficiaryType: string;
    companyData: CompanyData;
    beneficiaryInsures: Array<PreferredBeneficiaryInsure>;
}

/**
 * Interface used as company data form.
 * @name CompanyData
 */
export interface CompanyData {
    cuit: string,
    businessName: string,
    errorsMessages: Array<{field: string, message: string}>
}

/**
 * Interface used as beneficiary insures form.
 * @name PreferredBeneficiaryInsure
 */
export interface PreferredBeneficiaryInsure {
    name: string,
    lastname: string,
    dni: string,
    errorsMessages: Array<{field: string, message: string}>
}

/**
 * Interface used as beneficiary insures form.
 * @name radioBeneficiaryTypeValues
 */
export const getRadioBeneficiaryTypeValues = (beneficiaryType: {value: string, label: string}[], formData: any) => {
    return beneficiaryType.map((item: {value: string, label: string}, index: number) => {
        return {
            id: item.value,
            value: item.value,
            name: "beneficiaryType",
            labelDesktop: item.label,
            labelMobile: item.label,
            isChecked: formData.beneficiaryType === beneficiaryType[index].value,
        }
    })

};

export const validateForm = (currentForm: PreferredBeneficiaryForm): PreferredBeneficiaryForm => {
    if (currentForm.beneficiaryType === "FISICO") {
        currentForm.beneficiaryInsures.forEach((item: PreferredBeneficiaryInsure) => {
            item.errorsMessages = [];
            if (!(Validations.required(item.name))) {
                item.errorsMessages.push({field: "name", message: lang.errors.required});
            }
            else if(!(Validations.fullName(item.name))){
                item.errorsMessages.push({field: "name", message: lang.errors.invalid});
            }
            if (!(Validations.required(item.lastname))) {
                item.errorsMessages.push({field: "lastname", message: lang.errors.required});
            }
            else if(!(Validations.fullName(item.lastname))){
                item.errorsMessages.push({field: "lastname", message: lang.errors.invalid});
            }
            if (!(Validations.number(item.dni) && Validations.minLength(item.dni, 7) && Validations.maxLength(item.dni, 8))) {
                item.errorsMessages.push({field: "dni", message: lang.errors.invalid});
            }
        });

    } else if (currentForm.beneficiaryType === "JURIDICO") {
        currentForm.companyData.errorsMessages = [];
        if (!(Validations.required(currentForm.companyData.businessName as string))) {
            currentForm.companyData.errorsMessages.push({field: "businessName", message: lang.errors.required});
        }
        else if (!(Validations.alphaNumeric(currentForm.companyData.businessName as string, true) && Validations.maxLength(currentForm.companyData.businessName as string, 60))) {
            currentForm.companyData.errorsMessages.push({field: "businessName", message: lang.errors.invalid});
        }
        if (!Validations.cuil(currentForm.companyData?.cuit as string)) {
            currentForm.companyData.errorsMessages.push({field: "cuit", message: lang.errors.invalid});
        }
    }
    return currentForm;
}